<template>
  <div>
    <div class="page-container">
      <el-card class="card-top" shadow="hover">
        <div class="card-actions">
          <el-form :inline="true" :model="searchForm" size="small" @submit.native.prevent>
            <el-form-item label="用户姓名">
              <el-input v-model="searchForm.name" placeholder="请输入用户姓名" clearable />
            </el-form-item>
            <el-form-item label="身份证号">
              <el-input v-model="searchForm.idcard" placeholder="请输入身份证号" clearable />
            </el-form-item>
            <el-form-item label="开始时间">
              <el-date-picker
                v-model="searchForm.startDate"
                type="date"
                placeholder="选择开始时间"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                clearable
                style="width: 180px"
              />
            </el-form-item>
            <el-form-item label="结束时间">
              <el-date-picker
                v-model="searchForm.endDate"
                type="date"
                placeholder="选择结束时间"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                clearable
                style="width: 180px"
              />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleSearch">查询</el-button>
              <el-button @click="handleReset">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="action-btns">
          <el-button v-if="!isSubadmin" type="primary" @click="showCreateDialog = true">创建用户</el-button>
          <el-button type="primary" @click="handleExport">导出</el-button>
          <el-button v-if="!isSubadmin" type="primary" @click="showImportDialog = true">导入</el-button>
        </div>
      </el-card>
      <el-card class="card-table" shadow="hover">
        <el-table :data="users" border stripe style="width: 100%;" size="small" height="500px">
          <el-table-column prop="nickname" label="会员名称" align="center" />
          <el-table-column prop="name" label="用户姓名" align="center" />
          <el-table-column prop="idcard" label="身份证号" align="center">
            <template slot-scope="scope">
              <div 
                :class="{ 'duplicate-idcard': scope.row.hasDuplicateIdcard }"
                @click="scope.row.hasDuplicateIdcard ? handleIdcardClick(scope.row.idcard) : null"
              >
                {{ scope.row.idcard }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="mobile" label="手机号" align="center" />
          <el-table-column prop="status" label="状态" align="center" />
          <el-table-column prop="goodsTitle" label="报名类型" align="center" />
          <el-table-column prop="birthday" label="创建日期" align="center" />
          <el-table-column label="注册来源" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.uid === null">页面导入</span>
              <span v-else-if="scope.row.uid === -1">文件导入</span>
              <span v-else>系统注册</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="120">
            <template slot-scope="scope">
              <el-button v-if="!isSubadmin" type="text" size="small" style="color: #f56c6c;"  @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="table-pagination">
          <el-pagination background layout="prev, pager, next" :total="total" :page-size="size"
            :current-page="page" @current-change="handlePageChange" />
        </div>
      </el-card>
    </div>
    <el-dialog title="创建用户" :visible.sync="showCreateDialog" width="400px" @close="createForm = { name: '', idcard: '', mobile: '', goodsTitle: '', nickname: '' }">
      <el-form :model="createForm" :rules="createFormRules" ref="createForm" label-width="80px">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="createForm.name" autocomplete="off" />
        </el-form-item>
        <el-form-item label="身份证号" prop="idcard">
          <el-input v-model="createForm.idcard" autocomplete="off" />
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input v-model="createForm.mobile" autocomplete="off" />
        </el-form-item>
        <el-form-item label="报名类型" prop="goodsTitle">
          <el-select v-model="createForm.goodsTitle" placeholder="请选择报名类型" style="width: 100%">
            <el-option label="摩托车" value="摩托车" />
            <el-option label="小汽车" value="小汽车" />
          </el-select>
        </el-form-item>
        <el-form-item label="会员信息" prop="nickname">
          <el-input v-model="createForm.nickname" placeholder="请输入会员信息" autocomplete="off" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showCreateDialog = false">取 消</el-button>
        <el-button type="primary" :loading="createFormLoading" @click="handleCreate">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="导入用户数据" :visible.sync="showImportDialog" width="400px">
      <el-upload
        class="upload-demo"
        :show-file-list="false"
        :before-upload="beforeImportUpload"
        :on-change="handleImportChange"
        :auto-upload="false"
        accept=".xls,.xlsx,.csv"
      >
        <el-button type="primary">选择文件</el-button>
        <span style="margin-left: 12px; color: #888; font-size: 13px;">支持 .xls, .xlsx, .csv</span>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showImportDialog = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'

export default {
    name: 'UserManage',
    data() {
        return {
            users: [],
            total: 0,
            page: 1,
            size: 20,
            searchForm: {
                name: '',
                idcard: '',
                startDate: '',
                endDate: ''
            },
            showCreateDialog: false,
            createForm: {
                name: '',
                idcard: '',
                mobile: '',
                goodsTitle: '',
                nickname: ''
            },
            createFormLoading: false,
            createFormRules: {
                name: [
                    { required: true, message: '请输入姓名', trigger: 'blur' }
                ],
                idcard: [
                    { required: true, message: '请输入身份证号', trigger: 'blur' },
                    { pattern: /^(\d{17}[\dXx])$/, message: '身份证号格式不正确', trigger: 'blur' }
                ],
                mobile: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { pattern: /^\d{11}$/, message: '手机号格式不正确', trigger: 'blur' }
                ],
                goodsTitle: [
                    { required: true, message: '请选择报名类型', trigger: 'change' }
                ],
                nickname: [
                    { required: true, message: '请输入会员信息', trigger: 'blur' }
                ]
            },
            showImportDialog: false,
        }
    },
    computed: {
        isSubadmin() {
            return this.$store && this.$store.state && this.$store.state.userRole === 'subadmin'
        }
    },
    methods: {
        async fetchUsers() {
            try {
                const params = {
                    name: this.searchForm.name,
                    idcard: this.searchForm.idcard,
                    startDate: this.searchForm.startDate,
                    endDate: this.searchForm.endDate,
                    page: this.page,
                    size: this.size
                };
                const res = await axios.get('/api/users', { params });
                console.log("🚀 ~ fetchUsers ~ res:", res)
                this.users = res.data.content || [];
                this.total = res.data.totalElements || 0;
            } catch (e) {
                this.$message.error('获取用户列表失败');
            }
        },
        handleSearch() {
            this.page = 1;
            this.fetchUsers();
        },
        handleReset() {
            this.searchForm = {
                name: '',
                idcard: '',
                startDate: '',
                endDate: ''
            };
            this.page = 1;
            this.fetchUsers();
        },
        handlePageChange(val) {
            this.page = val;
            this.fetchUsers();
        },
        handleEdit(row) {
            // 编辑用户逻辑
            console.log('编辑用户:', row);
        },
        handleDelete(row) {
            // 删除用户逻辑
            this.$confirm('确认删除该用户?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                try {
                    const res = await axios.delete(`/api/users/${row.id}`);
                    if (res.data && res.data.code && res.data.code !== 200) {
                        this.$message.error(res.data.message || '删除失败');
                    } else {
                        this.$message.success('删除成功');
                        this.fetchUsers();
                    }
                } catch (e) {
                    this.$message.error((e.response && e.response.data && e.response.data.message) ? e.response.data.message : '删除失败');
                }
            });
        },
        handleCreate() {
            this.$refs.createForm.validate(async valid => {
                if (!valid) return;
                this.createFormLoading = true;
                try {
                    const res = await axios.post('/api/users', this.createForm);
                    if (res.data && res.data.code && res.data.code !== 200) {
                        this.$message.error(res.data.message || '创建失败');
                    } else {
                        this.$message.success('创建成功');
                        this.showCreateDialog = false;
                        this.fetchUsers();
                        this.createForm = { name: '', idcard: '', mobile: '', goodsTitle: '', nickname: '' };
                    }
                } catch (e) {
                    this.$message.error((e.response && e.response.data && e.response.data.message) ? e.response.data.message : '创建失败');
                } finally {
                    this.createFormLoading = false;
                }
            });
        },
        handleExport() {
            const params = {};
            if (this.searchForm.startDate) {
                params.startDate = this.searchForm.startDate;
            }
            if (this.searchForm.endDate) {
                params.endDate = this.searchForm.endDate;
            }
            
            const loading = this.$loading({
                lock: true,
                text: '正在导出，请稍候...',
                spinner: 'el-icon-loading',
                background: 'rgba(255, 255, 255, 0.7)'
            });
            
            axios({
                url: '/api/users/export',
                method: 'get',
                params,
                responseType: 'blob'
            }).then(res => {
                const blob = new Blob([res.data]);
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = '用户数据.csv';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            }).catch(() => {
                this.$message.error('导出失败');
            }).finally(() => {
                loading.close();
            });
        },
        beforeImportUpload(file) {
            const isExcelOrCsv = file.type === 'application/vnd.ms-excel' ||
                file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
                file.type === 'text/csv' ||
                file.name.endsWith('.xls') || file.name.endsWith('.xlsx') || file.name.endsWith('.csv');
            if (!isExcelOrCsv) {
                this.$message.error('只能上传 excel/csv 文件');
                return false;
            }
            return true;
        },
        async handleImportChange(file) {
            // file 是 {name, raw, ...}
            const rawFile = file.raw || file;
            const isExcelOrCsv = rawFile.type === 'application/vnd.ms-excel' ||
                rawFile.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
                rawFile.type === 'text/csv' ||
                rawFile.name.endsWith('.xls') || rawFile.name.endsWith('.xlsx') || rawFile.name.endsWith('.csv');
            if (!isExcelOrCsv) {
                this.$message.error('只能上传 excel/csv 文件');
                return false;
            }
            const loading = this.$loading({
                lock: true,
                text: '正在导入，请稍候...',
                spinner: 'el-icon-loading',
                background: 'rgba(255, 255, 255, 0.7)'
            });
            const formData = new FormData();
            formData.append('file', rawFile);
            try {
                const res = await axios.post('/api/users/import', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });
                if (res.data && res.data.code && res.data.code !== 200) {
                    this.$message.error(res.data.message || '导入失败');
                } else {
                    this.$message.success('导入成功');
                    this.showImportDialog = false;
                    this.fetchUsers();
                }
            } catch (e) {
                this.$message.error((e.response && e.response.data && e.response.data.message) ? e.response.data.message : '导入失败');
            } finally {
                loading.close();
            }
        },
        handleIdcardClick(idcard) {
            this.searchForm.idcard = idcard;
            this.handleSearch();
        },
    },
    mounted() {
        this.fetchUsers();
    }
}
</script>

<style lang="scss" scoped>
.page-container {
    padding: 24px 18px 0 18px;
    background: #f6f8fa;
    min-height: 100%;
}

.card-top {
    margin-bottom: 18px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.card-actions {
    display: flex;
    align-items: center;
    gap: 12px;
}

.card-table {
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.el-table {
    font-size: 15px;
    border-radius: 6px;
    overflow: hidden;
}

.table-pagination {
    margin-top: 18px;
    text-align: right;
}
.action-btns {
  // margin-top: 18px;
  display: flex;
  gap: 12px;
  padding-left: 0;
}

.duplicate-idcard {
  background-color: pink !important;
  cursor: pointer;
  padding: 0;
  margin: 0;
  border-radius: 0;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
}

/* 移除表格单元格的内边距 */
.el-table td {
  padding: 0 !important;
}

/* 确保身份证号列没有内边距 */
.el-table .el-table__cell {
  padding: 0 !important;
  position: relative;
}
</style>